/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const deleteScenarioDependencyRestRequestSchema = z.object({
  predecessorId: z.int().nullish(),
  successorId: z.int().nullish(),
});
